export const getBaseUrl = (): string => (
    process.env.BASE_URL ?? ''
);

export default { getBaseUrl };
